<template>
  <div>
    <iframe
      :src="url"
      frameborder="0"
      id="myiframe"
      width="100%"
      allowtransparency
      v-iframe-resize="{ log: true }"
    ></iframe>
  </div>
</template>

<script>
import { dashboardUrl } from "@/helpers/dashboards";
export default {
  computed: {
    url() {
      const user = this.$store.state.AsUser.nom === ""
        ? this.$store.state.user
        : this.$store.state.AsUser;
      if (!user || !user.id_role) { return ""; }
      // #1124 : dashboard complet pour le profil Administrateur, « hors achats » pour les autres
      const dashboard = dashboardUrl(this.$regle('stats').complet ? "statsComplet" : "stats");
      let param = "";
      if (user.id_role === 2 && user.type === "itinerant") {
        param = "?itinerant=";
      } else if (user.id_role === 2 && user.type === "sedentaire") {
        param = "?sedentaire=";
      }
      const name = user.id_role === 2 ? encodeURIComponent(user.nom) : "";
      const hide = user.id_role === 2 ? "#hide_parameters=itinerant,sedentaire,fournisseur" : "";
      return dashboard + param + name + hide;
    },
  },
};
</script>
